import ContactForm from '../components/ContactForm';
import Loading from '../../../components/Loading';
import useViewHelpAndSupport from './useViewHelpAndSupport';

export default function ViewMessageHelpAndSupport() {
    const {
        isLoading,
        isRefreshing,
        data,
        handleSubmitMessage,
        handleStatusChange,
        handleRefresh,
    } = useViewHelpAndSupport();

    return (
        <Loading loading={isLoading} >
            <ContactForm
                contact={data}
                key={data?.id}
                onHandleStatusChange={handleStatusChange}
                onSubmitMessage={handleSubmitMessage}
                onRefresh={handleRefresh}
                isRefreshing={isRefreshing}
            />
        </Loading>
    )
}
